export default __webpack_public_path__ + "static/media/EasytoAccess_Image.411721cd.png";